import React from "react";
import { Container, Card } from "react-bootstrap";
import { Briefcase } from "react-bootstrap-icons";
import "./experience.css";

const Experience = () => (
  <section id="experience">
    <Container>
      <h2 className=" mb-4">Experience</h2>
      <Card className="experience-card">
      <Card.Body>
        <div className="d-flex align-items-start">
          <div className="experience-icon">
    <Briefcase size={28} />
</div>
          <div>
            {/* <h5 className="fw-bold mb-1">
              Subject Matter Expert – Full Stack Developer
            </h5>
            <p className="mb-1 text-muted">
              Veniso Solutions Pvt Ltd, Hyderabad
            </p>
            <small className="text-secondary">July 2016 – Present</small>
            <br />
            <br /> */}
            {/* <hr /> */}
            <ul>
              <li>
                Architected full-stack applications using Node.js, Express, PHP,
                and React.js.
              </li>
              <li>
                Developed AI tools powered by OpenAI for dynamic database
                querying.
              </li>
              <li>
                Built OTT platforms with FFMPEG, HLS, AES encryption, and AWS S3
                integrations.
              </li>
              <li>
                Integrated telecom billing systems using RabbitMQ, CMS, and
                MySQL.
              </li>
              <li>
                Led backend API development, CI/CD pipelines (GitHub Actions),
                and server deployments using Docker.
              </li>
              <li>
                Managed subscription lifecycles, authentication, and performance
                optimization across large-scale systems.
              </li>
            </ul>
          </div>
        </div>
      </Card.Body>
      </Card>
    </Container>
  </section>
);

export default Experience;
